module.exports = __webpack_public_path__ + "static/media/profitfy-icon.490b2842.svg";